import { Row, Col } from 'reactstrap';

import Solde from '../../solde/pages';

const ReversHistory = () => {

  return (
    <div>
      <Row>
        <Col lg={12}>
          <Solde showButton = {false} showCard = {false}/>
        </Col>
      </Row>
    </div>
  );
};

export default ReversHistory;
